import React, { useMemo, useEffect, useCallback } from "react";
import { Grid } from "@mui/material";
import { DatePickerField, InputButton, InputDropDown, InputText } from "components/UI";
import {
  useGetDownloadAverageLocationGroup,
  useGetDownloadAverageRpackageOwner,
  useGetDownloadAverageRpackageType,
  useGetDownloadCarFamilyCode,
  useGetDownloadCarFamilyType,
  useGetDownloadCompanyCode,
  useGetDownloadExporter,
  useGetDownloadImporter,
  useGetDownloadLocationType,
  useGetDownloadReceiver,
  useGetDownloadSender,
  useGetDownloadSopExporter,
  useGetDownloadSopImporter,
  useGetDownloadSopRpackage,
  useGetDownloadSubseries,
  useGetDownloadTransportCategory,
  useGetDownloadTransportMode,
  useGetDownloadYear,
  // download excel
  useDownloadWorkingCalendarMutation,
  useDownloadTransportLeadTimeMutation,
  useDownloadCustomStockLeadTimeMutation,
  useDownloadSopMutation,
  useDownloadKatashikiMutation,
  useDownloadLeadTimeMutation,
  useDownloadAveLeadTimeGroupMutation,
} from "shared/services/master/downloadAndUpload";

import { findObject, responseDownloadFileErrors } from "utils";
import { COMMON_ENUM } from "shared/constants";

export default function DownloadMaster({
  searchForm,
  setSearchForm,
  downloadAndUploadMasterData,
  setMsgAlert,
  setIsClearUpload,
  setIsClearDownload,
  isClearDownload,
  setMsgError,
}) {
  const downloadWorkingCalendar = useDownloadWorkingCalendarMutation();
  const downloadTransportLeadTime = useDownloadTransportLeadTimeMutation();
  const downloadCustomStockLeadTime = useDownloadCustomStockLeadTimeMutation();
  const downloadSop = useDownloadSopMutation();
  const downloadKatashiki = useDownloadKatashikiMutation();
  const downloadLeadTime = useDownloadLeadTimeMutation();
  const downloadAveLeadTimeGroup = useDownloadAveLeadTimeGroupMutation();

  // working calendar
  const { data: downloadYearData } = useGetDownloadYear();
  const { data: downloadCompanyCodeData } = useGetDownloadCompanyCode({ year: searchForm.year });

  const { data: downloadTransportCategoryData } = useGetDownloadTransportCategory();

  const { data: downloadTransportModeData } = useGetDownloadTransportMode({
    transportCd: searchForm.transportCd,
  });

  const { data: downloadSenderData } = useGetDownloadSender({
    transportCd: searchForm.transportCd,
    transportMd: searchForm.transportMd,
  });

  const { data: downloadReceiverData } = useGetDownloadReceiver({
    transportCd: searchForm.transportCd,
    transportMd: searchForm.transportMd,
    senderCompId: searchForm.senderCompId,
  });

  const { data: downloadExporterData } = useGetDownloadExporter();

  const { data: downloadImporterData } = useGetDownloadImporter({
    expCompId: searchForm.expCompId,
  });

  const { data: downloadSopExporterData } = useGetDownloadSopExporter();

  const { data: downloadSopImporterData } = useGetDownloadSopImporter({
    expCompId: searchForm.expCompId,
  });

  const { data: downloadSopRpackageData } = useGetDownloadSopRpackage({
    expCompId: searchForm.expCompId,
    impCompId: searchForm.impCompId,
  });
  const { data: downloadCarFamilyData } = useGetDownloadCarFamilyType();

  const { data: downloadCarFamilyCodeData } = useGetDownloadCarFamilyCode();

  const { data: downloadSubseriesData } = useGetDownloadSubseries();

  const { data: downloadLocationTypeData } = useGetDownloadLocationType();

  const { data: downloadAverageRpackageOwnerData } = useGetDownloadAverageRpackageOwner();

  const { data: downloadAverageRpackageTypeData } = useGetDownloadAverageRpackageType({
    rPkgOwnerCompAbbr: COMMON_ENUM.C_SM_CTG_TMAP_EM,
  });

  const { data: downloadAverageLocationGroupData } = useGetDownloadAverageLocationGroup({
    locationTypeCd: searchForm.locationTypeCd,
  });

  // handle change download dropdown
  const handleChangeDownload = async e => {
    setMsgAlert([]);
    setMsgError([]);
    setIsClearUpload(true);

    setSearchForm(old => ({
      ...old,
      // reset upload
      upload: "",
      dataTableSearch: "",
      // download
      download: e.target.value,
      year: "",
      companyId: "",
      transportCd: "",
      transportMd: "",
      senderCompId: "",
      receiverCompId: "",
      effMonthFrom: "",
      effMonthTo: "",
      expCompId: "",
      impCompId: "",
      effDtFrom: "",
      effDtTo: "",
      rPkgTypeId: "",
      carFamilyTypeCd: "",
      carFamilyCd: "",
      subSeries: "",
      locationTypeCd: "",
      locationTypeDesc: "",
      rPkgOwnerCompAbbr: "",
      locationGroupId: "",
    }));
  };

  // handle clear click
  const handleClearDownloadClick = useCallback(() => {
    setMsgAlert([]);
    setMsgError([]);
    console.log("handleClearDownloadClick");
    setSearchForm(old => ({
      ...old,
      download: "",
      year: "",
      companyId: "",
      transportCd: "",
      transportMd: "",
      senderCompId: "",
      receiverCompId: "",
      effMonthFrom: "",
      effMonthTo: "",
      expCompId: "",
      impCompId: "",
      effDtFrom: "",
      effDtTo: "",
      rPkgTypeId: "",
      carFamilyTypeCd: "",
      carFamilyCd: "",
      subSeries: "",
      locationTypeCd: "",
      locationTypeDesc: "",
      rPkgOwnerCompAbbr: "",
      locationGroupId: "",
    }));
    setIsClearDownload(false);
  }, [setMsgAlert, setMsgError, setSearchForm]);

  useEffect(() => {
    if (isClearDownload) handleClearDownloadClick();
  }, [handleClearDownloadClick, isClearDownload]);

  // render form download
  const renderFormDownload = () => {
    switch (searchForm.download) {
      case "BDN910M0":
        return (
          <Grid container>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>R-Package Owner : </strong>
              <InputDropDown
                value={searchForm.rPkgOwnerCompAbbr}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    rPkgOwnerCompAbbr: e.target.value,
                    rPkgTypeId: "",
                  }))
                }
                memu={downloadAverageRpackageOwnerData?.map(val => ({
                  key: val.rPkgOwnerCompAbbr,
                  value: val.rPkgOwnerCompAbbr,
                }))}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>R-Package Type : </strong>
              <InputDropDown
                value={searchForm.rPkgTypeId}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    rPkgTypeId: e.target.value,
                  }))
                }
                memu={downloadAverageRpackageTypeData?.map(val => ({
                  key: val.rPkgType,
                  value: val.rPkgType,
                }))}
                disabled={searchForm.rPkgOwnerCompAbbr === ""}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Location Type : </strong>
              <InputDropDown
                value={searchForm.locationTypeCd}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    locationTypeCd: e.target.value,
                    locationGroupId: "",
                  }))
                }
                memu={downloadLocationTypeData?.map(val => ({
                  key: val.cd,
                  value: val.value,
                }))}
                defaultValue=""
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Location Group : </strong>
              {searchForm.locationTypeCd === "P" ? (
                <InputDropDown
                  value={searchForm?.locationGroupId}
                  onChange={e =>
                    setSearchForm(old => ({
                      ...old,
                      locationGroupId: e.target.value,
                    }))
                  }
                  memu={downloadAverageLocationGroupData?.map(val => ({
                    key: val.locationGroupId,
                    value: val.locationGroup,
                  }))}
                  defaultValue=""
                  disabled={searchForm.locationTypeCd === ""}
                  placeholder="<All>"
                />
              ) : (
                <InputDropDown
                  value={searchForm?.locationGroupId}
                  onChange={e =>
                    setSearchForm(old => ({
                      ...old,
                      locationGroupId: e.target.value,
                    }))
                  }
                  memu={downloadAverageLocationGroupData?.map(val => ({
                    key: val.locationGroup,
                    value: val.locationGroup,
                  }))}
                  defaultValue=""
                  disabled={searchForm.locationTypeCd === ""}
                  placeholder="<All>"
                />
              )}
            </Grid>
          </Grid>
        );

      case "BDN910G0":
        return (
          <Grid container alignItems="center">
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Exporter : </strong>
              <InputDropDown
                id="select_expCompId"
                value={searchForm.expCompId}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    expCompId: e.target.value,
                    impCompId: "",
                  }))
                }
                memu={downloadExporterData?.map(val => ({
                  key: val.expCompId,
                  value: val.expCompAbbr,
                }))}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Importer : </strong>
              <InputDropDown
                id="select_impCompId"
                value={searchForm.impCompId}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    impCompId: searchForm.expCompId === "" ? "" : e.target.value,
                  }))
                }
                memu={downloadImporterData?.map(val => ({
                  key: val.impCompId,
                  value: val.impCompAbbr,
                }))}
                disabled={searchForm.expCompId === ""}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Effective Date (From) : </strong>
              <DatePickerField
                fullWidth={true}
                value={searchForm.effDtFrom}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    effDtFrom: e,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Effective Date (To) : </strong>
              <DatePickerField
                fullWidth={true}
                value={searchForm.effDtTo}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    effDtTo: e,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        );

      case "BDN910I0":
        return (
          <Grid container>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Car Family Type : </strong>
              <InputDropDown
                placeholder="<All>"
                value={searchForm.carFamilyTypeCd}
                memu={downloadCarFamilyData?.map(val => ({
                  key: val.carFamilyTypeCd,
                  value: val.carFamilyType,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    carFamilyTypeCd: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Car Family Code : </strong>
              <InputDropDown
                placeholder="<All>"
                value={searchForm.carFamilyCd}
                memu={downloadCarFamilyCodeData?.map(val => ({
                  key: val.carFamilyCd,
                  value: val.carFamilyCd,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    carFamilyCd: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Sub Series : </strong>
              <InputDropDown
                placeholder="<All>"
                value={searchForm.subSeries}
                memu={downloadSubseriesData?.map(val => ({
                  key: val.subSeries,
                  value: val.subSeries,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    subSeries: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={7}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Effective Date (From) : </strong>
              <DatePickerField
                fullWidth={true}
                value={searchForm.effDtFrom}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    effDtFrom: e,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Effective Date (To) : </strong>
              <DatePickerField
                fullWidth={true}
                value={searchForm.effDtTo}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    effDtTo: e,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        );

      case "BDN910L0":
        return (
          <Grid container>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>*Location Type : </strong>
              <InputDropDown
                required
                value={searchForm.locationTypeCd}
                memu={downloadLocationTypeData?.map(val => ({
                  key: val.cd,
                  value: val.value,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    locationTypeCd: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Location Desc : </strong>
              <InputText
                fullWidth
                value={searchForm.locationTypeDesc}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    locationTypeDesc: e.target.value,
                  }))
                }
                regularExp=""
              />
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        );

      case "BDN910H0":
        return (
          <Grid container>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Exporter : </strong>
              <InputDropDown
                value={searchForm.expCompId}
                memu={downloadSopExporterData?.map(val => ({
                  key: val.expCompId,
                  value: val.expCompAbbr,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    expCompId: e.target.value,
                    impCompId: "",
                    rPkgTypeId: "",
                  }))
                }
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Importer : </strong>
              <InputDropDown
                value={searchForm.impCompId}
                memu={downloadSopImporterData?.map(val => ({
                  key: val.impCompId,
                  value: val.impCompAbbr,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    impCompId: searchForm.expCompId === "" ? "" : e.target.value,
                    rPkgTypeId: "",
                  }))
                }
                disabled={searchForm.expCompId === ""}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>R-Package Type : </strong>
              <InputDropDown
                value={searchForm.rPkgTypeId}
                memu={downloadSopRpackageData?.map(val => ({
                  key: val.rPkgTypeId,
                  value: val.rPkgType,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    rPkgTypeId: searchForm.impCompId === "" ? "" : e.target.value,
                  }))
                }
                disabled={searchForm.impCompId === ""}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        );

      case "BDN910F0":
        return (
          <Grid container>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>*Transportation Category : </strong>
              <InputDropDown
                required
                value={searchForm.transportCd}
                memu={downloadTransportCategoryData?.map(val => ({
                  key: val.transportCd,
                  value: val.transportCategoryName,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    transportCd: e.target.value,
                    transportMd: "",
                    senderCompId: "",
                    receiverCompId: "",
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>*Transportation Mode : </strong>
              <InputDropDown
                required
                value={searchForm.transportMd}
                memu={downloadTransportModeData?.map(val => ({
                  key: val.transportMd,
                  value: val.transportModeName,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    transportMd: searchForm.transportCd === "" ? "" : e.target.value,
                    senderCompId: "",
                    receiverCompId: "",
                  }))
                }
                disabled={searchForm.transportCd === ""}
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Sender : </strong>
              <InputDropDown
                value={searchForm.senderCompId}
                memu={downloadSenderData?.map(val => ({
                  key: val.senderCompId,
                  value: val.senderCompAbbr,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    senderCompId: searchForm.transportMd === "" ? "" : e.target.value,
                    receiverCompId: "",
                  }))
                }
                disabled={searchForm.transportMd === ""}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Receiver : </strong>
              <InputDropDown
                value={searchForm.receiverCompId}
                memu={downloadReceiverData?.map(val => ({
                  key: val.receiverCompId,
                  value: val.receiverCompAbbr,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    receiverCompId: searchForm.senderCompId === "" ? "" : e.target.value,
                  }))
                }
                disabled={searchForm.senderCompId === ""}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Effective Month (From) : </strong>
              <DatePickerField
                views={["month", "year"]}
                format="MM/YYYY"
                mask="MM/YYYY"
                fullWidth={true}
                value={searchForm.effMonthFrom}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    effMonthFrom: e,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Effective Month (To) : </strong>
              <DatePickerField
                views={["month", "year"]}
                format="MM/YYYY"
                mask="MM/YYYY"
                fullWidth
                value={searchForm.effMonthTo}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    effMonthTo: e,
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        );

      case "BDN910E0":
        return (
          <Grid container>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>*Year : </strong>
              <InputDropDown
                required
                value={searchForm.year}
                memu={downloadYearData?.map(val => ({
                  key: val.year,
                  value: val.year,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    year: e.target.value,
                    companyId: "",
                  }))
                }
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} style={{ display: "flex" }}>
              <strong style={{ margin: "auto 0px", width: "325px" }}>Company Code : </strong>
              <InputDropDown
                value={searchForm.companyId}
                memu={downloadCompanyCodeData?.map(val => ({
                  key: val.companyId,
                  value: val.companyAbbr,
                }))}
                onChange={e =>
                  setSearchForm(old => ({
                    ...old,
                    companyId: searchForm.year === "" ? "" : e.target.value,
                  }))
                }
                disabled={searchForm.year === ""}
                placeholder="<All>"
              />
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        );

      default:
        break;
    }
    return null;
  };

  // handle download click
  const handleDownloadClick = async () => {
    try {
      setMsgAlert([]);
      setMsgError([]);

      let option = {};

      switch (searchForm.download) {
        case "BDN910E0":
          option = {
            dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
            year: searchForm.year,
            companyId: searchForm.companyId,
          };
          // filename = "Working_Calendar_Master";
          await downloadWorkingCalendar(option);
          return true;

        case "BDN910F0":
          option = {
            dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
            transportCd: searchForm.transportCd,
            transportMd: searchForm.transportMd,
            senderCompId: searchForm.senderCompId,
            receiverCompId: searchForm.receiverCompId,
            effMonthFrom: searchForm.effMonthFrom,
            effMonthTo: searchForm.effMonthTo,
            // effMonthFrom: formatDate(searchForm.effMonthFrom, "MM/YYYY"),
            // effMonthTo: formatDate(searchForm.effMonthTo, "MM/YYYY"),
          };
          await downloadTransportLeadTime(option);
          return true;

        case "BDN910G0":
          option = {
            dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
            expCompId: searchForm.expCompId,
            impCompId: searchForm.impCompId,
            effDtFrom: searchForm.effDtFrom,
            effDtTo: searchForm.effDtTo,
          };
          await downloadCustomStockLeadTime(option);
          return true;

        case "BDN910H0":
          option = {
            dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
            expCompId: searchForm.expCompId,
            impCompId: searchForm.impCompId,
            rPkgTypeId: searchForm.rPkgTypeId,
          };
          await downloadSop(option);
          return true;

        case "BDN910I0":
          option = {
            dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
            carFamilyTypeCd: searchForm.carFamilyTypeCd,
            carFamilyCd: searchForm.carFamilyCd,
            subSeries: searchForm.subSeries,
            effDtFrom: searchForm.effDtFrom,
            effDtTo: searchForm.effDtTo,
          };
          await downloadKatashiki(option);
          return true;

        case "BDN910L0":
          option = {
            dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
            locationTypeCd: searchForm.locationTypeCd,
            locationTypeDesc: searchForm.locationTypeDesc,
          };
          await downloadLeadTime(option);
          return true;

        case "BDN910M0":
          option = {
            dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
            rPkgOwnerCompAbbr: searchForm.rPkgOwnerCompAbbr,
            rPkgType: searchForm.rPkgTypeId,
            locationTypeCd: searchForm.locationTypeCd,
            locationGroup: !searchForm.locationGroupId
              ? ""
              : searchForm.locationTypeCd === "P"
                ? findObject({
                    data: downloadAverageLocationGroupData,
                    value: searchForm.locationGroupId,
                    property: "locationGroupId",
                    field: "locationGroup",
                  })
                : findObject({
                    data: downloadAverageLocationGroupData,
                    value: searchForm.locationGroupId,
                    property: "locationGroup",
                    field: "locationGroup",
                  }),
          };

          let res = await downloadAveLeadTimeGroup(option);

          return true;

        default:
          return;
        // break;
      }
    } catch (error) {
      const err = responseDownloadFileErrors(error);
      setMsgError(err);
      window.scroll(0, 0);
      return;
    }
  };

  const downloadMasterList = useMemo(() => {
    if (downloadAndUploadMasterData) {
      downloadAndUploadMasterData?.sort((a, b) => {
        return a?.value.toLowerCase().localeCompare(b?.value.toLowerCase());
      });
      return downloadAndUploadMasterData;
    }
    return downloadAndUploadMasterData;
  }, [downloadAndUploadMasterData]);
  return (
    <Grid container sx={{ alignItems: "center" }}>
      <Grid item xs={5} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 0px", width: "325px" }}>*Download Master : </strong>
        <InputDropDown
          id="select_download"
          required
          value={searchForm.download}
          onChange={e => handleChangeDownload(e)}
          memu={downloadMasterList?.map(val => ({
            key: val.cd,
            value: val.value,
          }))}
        />
      </Grid>
      <Grid item xs={7}></Grid>

      {renderFormDownload()}

      {searchForm.download !== "" && (
        <Grid item xs={12} display="flex" justifyContent="flex-end" marginTop={2}>
          <InputButton value="Download" onClick={handleDownloadClick} name={"WDN910B0Download"} />
          <InputButton
            value="Clear"
            onClick={handleClearDownloadClick}
            id="download_clear_btn"
            name={"WDN910B0Clear2"}
          />
        </Grid>
      )}
    </Grid>
  );
}
